import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export default class ResultTemplate extends Model {
  // 获取面试结果页配置信息
  static get(param: any) {
    return request.post("aiExam/result/templateGet", param).then(resp => {
      return resp.data.data;
    });
  }
  // 创建或修改面试结果页配置信息
  static createOrUpdate(param: any) {
    return request
      .post("aiExam/result/templateCreateOrUpdate", param)
      .then(resp => {
        return resp.data.data;
      });
  }
  // 面试信息登记项获取
  static getConnect(code: string) {
    return request
      .post("aiExam/old/connect", {
        connectCode: code
      })
      .then(resp => {
        return resp.data.data;
      });
  }
}
